<template>
	<div class="logo">
		<router-link to="/">
			<img alt="logo" src="~@/assets/logo.svg" />
			<h1 v-if="showTitle">{{ title }}</h1>
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'Logo',
	props: {
		title: {
			type: String,
			default: '中保车服',
			required: false,
		},
		showTitle: {
			type: Boolean,
			default: true,
			required: false,
		},
	},
}
</script>
